import Vue from 'vue';
import ToastView from './index.vue';

const Toast = Vue.extend(ToastView);

function toast(message, type = 'iconic_smile', duration = 1500) {
  let instance = new Toast();

  instance.message = message;
  instance.type = type;

  instance.close = () => {
    document.body.removeChild(instance.$el);
    instance.$destroy();
    instance = null;
  };

  instance.$mount();
  document.body.appendChild(instance.$el);

  setTimeout(() => {
    instance.close();
  }, duration);

  return instance;
}

toast.success = (message, duration) =>
  toast(message, 'iconic_success', duration);

export default toast;
